import { httpClient } from '../httpClient';

export const dataflowCoreApi = {
  // Sources
  listSources: (params) =>
    httpClient.get('/dataflow/sources', { params }),

  createSource: (data) =>
    httpClient.post('/dataflow/source', data),

  updateSource: (id, data) =>
    httpClient.put(`/dataflow/source/${id}`, data),

  deleteSource: (id) =>
    httpClient.delete(`/dataflow/source/${id}`),

  restoreSource: (id) =>
    httpClient.post(`/dataflow/source/${id}/restore`),

  // In-Kingdom Systems
  listInKingdom: (params) =>
    httpClient.get('/dataflow/in-kingdom-systems', { params }),

  createInKingdom: (data) =>
    httpClient.post('/dataflow/inKingdom', data),

  updateInKingdom: (id, data) =>
    httpClient.put(`/dataflow/inKingdom/${id}`, data),

  deleteInKingdom: (id) =>
    httpClient.delete(`/dataflow/inKingdom/${id}`),

  restoreInKingdom: (id) =>
    httpClient.post(`/dataflow/inKingdom/${id}/restore`),

  // Cross-Border Systems
  listCrossBorder: (params) =>
    httpClient.get('/dataflow/cross-border-systems', { params }),

  createCrossBorder: (data) =>
    httpClient.post('/dataflow/crossBorder', data),

  updateCrossBorder: (id, data) =>
    httpClient.put(`/dataflow/crossBorder/${id}`, data),

  deleteCrossBorder: (id) =>
    httpClient.delete(`/dataflow/crossBorder/${id}`),

  restoreCrossBorder: (id) =>
    httpClient.post(`/dataflow/crossBorder/${id}/restore`),

  // Flows
  listFlows: (params) =>
    httpClient.get('/dataflow/flows', { params }),

  createFlow: (data) =>
    httpClient.post('/dataflow/flows', data),

  updateFlow: (id, data) =>
    httpClient.put(`/dataflow/flows/${id}`, data),

  deleteFlow: (id) =>
    httpClient.delete(`/dataflow/flows/${id}`),

  restoreFlow: (id) =>
    httpClient.post(`/dataflow/flows/${id}/restore`),

  // Stats & Export
  getStats: () =>
    httpClient.get('/dataflow/stats'),

  getCommandCenter: () =>
    httpClient.get('/dataflow/command-center'),

  exportReport: (language) =>
    httpClient.post('/dataflow/export-report', { language }, { responseType: 'blob' }),
};
